module.exports = __webpack_public_path__ + "static/media/BIMpic6.c810bbf1.png";